import { reactive } from 'vue'
import { useProductApi } from './'

export function useProduct() {
  const { fetchProducts } = useProductApi()

  const products = reactive({
    approvedProducts: {},
    notApprovedProducts: {}
  })

  const enrichProducts = async (
    decisionProductList = {},
    onError = () => {
      console.log('apiNotAvailable')
    }
  ) => {
    await fetchProducts(Object.keys(decisionProductList))
      .then((response) => {
        if (!response.ok) {
          console.error(`productAPI server-error`, response)
          onError('apiError')
          return false
        }
        return response.json()
      })
      .then(({ data }) => {
        if (!data) {
          return
        }
        transformAndCategorizeProducts(data, decisionProductList)
      })
      .catch((e) => {
        console.error('productAPI not available', e)
        onError('apiNotAvailable')
      })
  }

  const transformAndCategorizeProducts = (enrichedProductList, decisionProductList) => {
    enrichedProductList.forEach((productFromApiProduct) => {
      const approvementCategory = decisionProductList[productFromApiProduct.sku].istGenehmigt
        ? 'approvedProducts'
        : 'notApprovedProducts'
      if (!products[approvementCategory][productFromApiProduct.kategorie]) {
        const masterProduct =
          enrichedProductList.find((p) => p.sku === productFromApiProduct.skuMaster) ||
          productFromApiProduct
        products[approvementCategory][masterProduct.kategorie] = {
          name: masterProduct.nameProduktauswahl || decisionProductList.sku,
          istGenehmigt: decisionProductList[masterProduct.sku].istGenehmigt,
          bildLink: masterProduct.bilderLinks[0],
          sku: masterProduct.skuMaster,
          produktgruppe: masterProduct.produktgruppe,
          varianten: []
        }
      }
      products[approvementCategory][productFromApiProduct.kategorie].varianten.push({
        ...decisionProductList[productFromApiProduct.sku],
        ...productFromApiProduct
      })
    })
  }

  const ausgewaehlteProdukte = () => {
    const allChosenProducts = {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(products.approvedProducts).forEach(([key, masterProduct]) => {
      masterProduct.varianten.forEach((varianz) => {
        allChosenProducts[varianz.sku] = {
          gewaehlteAnzahl: varianz.gewaehlteAnzahl,
          gewaehlteAllergien: varianz.allergies
        }
      })
    })
    return allChosenProducts
  }

  return { enrichProducts, products, ausgewaehlteProdukte }
}
